var _rect, _rect2, _rect3, _path, _path2, _g, _rect4, _rect5, _rect6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDevices = function SvgDevices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 80,
    viewBox: "0 0 134 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 103.198,
    y: 35.5984,
    width: 13.6,
    height: 26,
    rx: 4,
    fill: "url(#devices_svg__paint0_linear_9773_32846)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70.3984,
    y: 12.7983,
    width: 28.4,
    height: 36.8,
    rx: 4,
    fill: "url(#devices_svg__paint1_linear_9773_32846)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.7983,
    y: 26.7983,
    width: 62,
    height: 40.4,
    rx: 4,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "devices_svg__mask0_9773_32846",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 12,
    width: 101,
    height: 56
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3976 16.7976C70.3976 14.5885 72.1885 12.7976 74.3976 12.7976H94.7976C97.0068 12.7976 98.7976 14.5885 98.7976 16.7976V45.5976C98.7976 47.8068 97.0067 49.5976 94.7976 49.5976H78.7976V63.1976C78.7976 65.4067 77.0067 67.1976 74.7976 67.1976H20.7976C18.5885 67.1976 16.7976 65.4067 16.7976 63.1976V30.7976C16.7976 28.5885 18.5885 26.7976 20.7976 26.7976H70.3976V16.7976ZM103.198 39.5976C103.198 37.3885 104.988 35.5976 107.198 35.5976H112.798C115.007 35.5976 116.798 37.3885 116.798 39.5976V57.5976C116.798 59.8067 115.007 61.5976 112.798 61.5976H107.198C104.988 61.5976 103.198 59.8067 103.198 57.5976V39.5976Z",
    fill: "#F5F5F5"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#devices_svg__mask0_9773_32846)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "devices_svg__mask1_9773_32846",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 32,
    width: 81,
    height: 38
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.0634 34.7682C57.3909 34.7682 40.5664 50.4015 39.4815 69.9993L37.1714 69.8714C38.3277 48.9835 56.2278 32.4546 78.0634 32.4546C97.5143 32.4546 113.834 45.5647 117.992 63.1917L115.74 63.7228C111.835 47.1686 96.4704 34.7682 78.0634 34.7682Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#devices_svg__mask1_9773_32846)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#devices_svg__filter0_f_9773_32846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6.48056 24.66C-7.51685 32.5877 -8.47308 40.5412 -9.54939 48.4561C-10.5375 56.0003 -6.25086 58.6754 8.14323 63.1033C41.2665 73.2529 74.3383 84.1442 107.437 94.8246C113.161 96.6647 118.083 95.9325 118.427 93.1898C120.874 73.6834 123.324 54.1578 125.852 34.6772L-6.48056 24.66Z",
    fill: "#FFB9F8"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#devices_svg__filter1_f_9773_32846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.0536 94.8258C56.0494 94.8268 56.0478 94.8211 56.0517 94.8189C75.065 83.9762 100.097 72.9837 128.381 63.2535C129.554 62.8506 130.731 62.4503 131.912 62.0522C139.088 59.6346 144.125 52.116 143.382 44.6811C142.479 35.6617 133.64 31.0325 125.233 35.1212L64.101 64.8546C58.0645 67.7906 54.2169 74.4756 54.8049 80.9669C55.2231 85.5842 55.6356 90.2026 56.0569 94.8212C56.0571 94.8232 56.0556 94.8253 56.0536 94.8258Z",
    fill: "#FFE665"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#devices_svg__filter2_f_9773_32846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.6331 42.4879C26.9559 47.7541 18.2743 53.0134 9.58657 58.2813C18.0503 55.8959 26.9868 52.7569 35.7235 49.4002C43.5675 46.3841 51.6118 43.1227 58.8243 41.543C64.9185 40.2068 69.9861 40.146 74.6206 40.6144C83.813 38.1358 91.9851 37.2099 99.0123 37.9837C104.265 38.564 102.171 40.8671 104.999 43.2125C97.5252 45.3751 104.66 48.2686 112.115 46.3134C115.169 45.5127 113.96 45.1946 116.763 44.7936C118.72 44.5189 121.356 42.5158 122.958 42.6417C130.262 43.2339 146.164 35.0311 152.65 36.3998C153.372 29.6484 130.642 36.6671 126.939 32.4248C109.515 37.0574 107.962 33.3679 94.7147 32.5425C93.6249 32.4731 91.6203 29.3156 90.5571 29.2157L51.2254 32.5425C48.6293 33.9388 38.1386 40.9701 35.6331 42.4879Z",
    fill: "#71BBFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#devices_svg__filter3_f_9773_32846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.6476 49.0311C72.6997 42.6101 87.5766 30.8269 90.098 20.754C80.1604 16.8786 83.0774 32.7661 73.1398 28.8907L58.8221 40.0716C57.2492 45.5367 54.0015 45.6593 62.6476 49.0311Z",
    fill: "#0A9F68"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#devices_svg__filter4_f_9773_32846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.436833 78.8656C0.151159 79.2713 0.220368 79.7114 -0.0746245 80.137C-0.369617 80.5626 -1.21635 81.6811 -1.10625 81.9213C-0.947143 82.2684 -1.16941 82.9197 -0.322834 83.0441C0.495369 83.1644 1.64203 82.8121 2.49743 82.61C5.63715 81.8679 8.66051 80.7043 11.6925 79.7713C13.2258 79.2994 14.8633 79.0746 16.4403 78.645C17.2087 78.4357 17.5536 78.1314 18.4228 78.0215C19.2576 77.9159 20.0322 77.6666 20.8248 77.4507C22.7429 76.9283 24.5631 76.8477 26.5626 76.6395C28.7699 76.4096 31.6343 75.4478 33.64 74.758C40.0496 72.5536 43.9401 68.8784 48.9093 65.755C50.8369 64.5434 52.3638 63.1548 54.4706 62.0316C56.6897 60.8486 59.2401 60.1386 61.8656 59.4234C66.3431 58.2038 71.3094 56.9501 75.3548 55.1738C77.2294 54.3506 78.8439 53.45 79.8562 52.1845C80.9474 50.8205 79.4716 48.6967 77.6898 47.9679C76.7005 47.5633 74.4019 47.627 73.1382 47.6673C71.7979 47.7101 70.4611 47.8467 69.1244 47.9998C64.1333 48.5712 59.2404 50.22 55.1136 52.1595C49.933 54.5942 44.4817 55.0484 38.6935 56.3909C35.9166 57.035 33.2737 57.8982 30.6484 58.7401C28.9082 59.2981 27.6839 60.6384 26.4021 61.4928C22.8003 63.8934 20.8841 66.8329 16.5736 68.8468C14.5723 69.7818 12.4502 70.688 10.179 71.331C8.94368 71.6807 7.08353 72.1758 6.15434 72.8448C4.42706 74.0884 2.1826 75.4758 1.52048 77.03C1.27903 77.5968 0.818329 78.3239 0.436833 78.8656Z",
    fill: "#FFE665"
  }))))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 77.1992,
    y: 29.9991,
    width: 1.6,
    height: 10.8,
    fill: "#F6F6F6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 103.199,
    y: 38.3992,
    width: 1.6,
    height: 12.8,
    fill: "#F6F6F6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 97.1992,
    y: 33.9991,
    width: 1.6,
    height: 11.6,
    fill: "#ECECEC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "devices_svg__filter0_f_9773_32846",
    x: -13.6846,
    y: 20.6599,
    width: 143.536,
    height: 79.1793,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_9773_32846"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "devices_svg__filter1_f_9773_32846",
    x: 50.7458,
    y: 29.6217,
    width: 96.7085,
    height: 69.2042,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_9773_32846"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "devices_svg__filter2_f_9773_32846",
    x: 5.58667,
    y: 25.2157,
    width: 151.08,
    height: 37.0656,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_9773_32846"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "devices_svg__filter3_f_9773_32846",
    x: 52.8997,
    y: 16.1399,
    width: 41.1982,
    height: 36.8912,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_9773_32846"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "devices_svg__filter4_f_9773_32846",
    x: -5.11597,
    y: 43.6375,
    width: 89.3455,
    height: 43.4312,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_9773_32846"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "devices_svg__paint0_linear_9773_32846",
    x1: 123.116,
    y1: 80.4054,
    x2: 124.593,
    y2: 30.6442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "devices_svg__paint1_linear_9773_32846",
    x1: 79.8036,
    y1: 43.9508,
    x2: 92.9903,
    y2: 12.6821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })))));
};
export default SvgDevices;